import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { FileDeleteConfirmComponent } from '../../file-delete-confirm/file-delete-confirm.component';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { FileService } from 'src/app/shared/services/file.service';
import { Subscription } from 'rxjs';
import { EMPTY_GUID } from 'src/app/shared/constants/empty-guid-.constant';
import { AttachmentFileTypes } from 'src/app/shared/constants/file.constants';
import { PropertyManagerSettings } from 'src/app/settings/models/property-manager-settings.model';
import { SettingsManagementService } from 'src/app/core/services/http/agency-mgmt/settings-management.service';

@Component({
  selector: 'app-uploaded-file-preview',
  templateUrl: './uploaded-file-preview.component.html',
  styleUrls: ['./uploaded-file-preview.component.scss'],
})
export class UploadedFilePreviewComponent implements OnInit, OnDestroy {
  subscription: Subscription;
  file: any;
  public drawerOpened = false;
  _showImageEditor = false;
  isImageEditor = false;
  jobId = EMPTY_GUID;
  AttachmentFileTypesEnum = AttachmentFileTypes;

  @Input()
  public files: any[] = [];
  public filesCount: number;

  @Input() set showImageEditor(value: boolean) {
    this._showImageEditor = value;
  }
  @Input() isScanForAssets: boolean = false;
  @Input() showBeforeAfterTag: boolean = false;

  @Output() delete = new EventEmitter<any>();
  @Output() scanForAsset = new EventEmitter<any>();

  constructor(
    private bottomSheet: MatBottomSheet,
    private fileService: FileService,
  ) {}

  ngOnDestroy(): void {
    if (this.subscription) this.subscription.unsubscribe();
  }

  ngOnInit(): void {
    this.subscription = this.fileService.fileDeleteEvent.subscribe({
      next: (result: boolean) => {
        if (result) {
          const index = this.files.findIndex(
            (element) => element.name == this.file.name
          );
          if (index > -1) {
            this.files.splice(index, 1);
            this.delete.emit(this.file);
          }
          this.file = null;
        }
      },
      error: () => {},
    });
  }

  deleteFile(file: any) {
    this.file = null;
    this.file = file;
    this.bottomSheet.open(FileDeleteConfirmComponent);
  }

  fileToPreview: { url: string; type: AttachmentFileTypes; comment: string; isAfter: boolean } = {
    url: null,
    type: AttachmentFileTypes.Other,
    comment: null,
    isAfter: false,
  };

  previewFile(file: any) {
    switch (this.getExtension(file.name)) {
      case 'msg':
        return '../../../../../assets/images/attached-file-msg.svg';
      case 'eml':
        return '../../../../../assets/images/attached-file-eml.svg';
      case 'pdf':
        return '../../../../../assets/images/attached-file-pdf.svg';
      case 'tiff':
        return '../../../../../assets/images/attached-file-tiff.svg';
      case 'csv':
        return '../../../../../assets/images/attached-file-csv.svg';
      case 'xls':
        return '../../../../../assets/images/attached-file-xls.svg';
      case 'xlsx':
        return '../../../../../assets/images/attached-file-xlsx.svg';
      default:
        return file.url;
    }
  }

  getExtension(fileName: string) {
    if(fileName)
      return fileName.split('.').pop().toLocaleLowerCase();

    return '';
  }

  getType(filename: string): AttachmentFileTypes {

    const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'tiff'];
    const videoExtensions = [
      'mp4',
      'wmv',
      'avi',
      'mov',
      '3gp',
      'flv',
      'm3u8',
      'ts',
    ];
    const emailExtensions = ['eml', 'msg'];

    if (imageExtensions.some((ext) => ext == this.getExtension(filename))) {
      return AttachmentFileTypes.Images;
    } else if (
      videoExtensions.some((ext) => ext == this.getExtension(filename))
    ) {
      return AttachmentFileTypes.Videos;
    } else if (
      emailExtensions.some((ext) => ext == this.getExtension(filename))
    ) {
      return AttachmentFileTypes.Email;
    } else if (this.getExtension(filename).toLowerCase() == 'pdf') {
      return AttachmentFileTypes.Pdf;
    }
    else if (filename && (filename.indexOf('.xls')  || filename.indexOf('.xlsx'))) {
      return AttachmentFileTypes.Excel;
    }
    return AttachmentFileTypes.Other;
  }
  getScannedImageType(filename: string): AttachmentFileTypes{
    const imageScanExtensions = ['jpg', 'jpeg', 'png']
    if (imageScanExtensions.some((ext) => ext == this.getExtension(filename))) {
      return AttachmentFileTypes.ScannedImages;
    }
    return AttachmentFileTypes.Other;
  }

  openDrawer(file: any): void {
    this.isImageEditor = false;
    this.detailsRequiredToDrawer(file);
  }

  openImageEditorDrawer(file: any): void {
    this.isImageEditor = true;
    this.detailsRequiredToDrawer(file);
  }

  detailsRequiredToDrawer(file: any): void {
    this.fileToPreview.type = this.getType(file.name);
    this.fileToPreview.url = file.url;
    this.fileToPreview.comment = file.comment;
    this.fileToPreview.isAfter = true;
    this.drawerOpened = true;
  }

  download(url: string): void {
    const filename = url.substring(url.lastIndexOf('/') + 1);
    const request = new XMLHttpRequest();
    request.open('GET', url, true);
    request.responseType = 'blob';
    request.onload = function () {
      if (this.status === 200) {
        var file = window.URL.createObjectURL(this.response);
        var a = document.createElement('a');
        a.href = file;
        a.download = filename || 'Attachment';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      }
    };
    request.send();
  }

  isPreviewOnly(file: any) {
    const defaultFilePreviewExtentions = ['msg', 'eml', 'tiff', 'csv'];
    return defaultFilePreviewExtentions.some(
      (extention) => this.getExtension(file.name) == extention
    );
  }
  isImage(file: any): boolean {
    return this.getType(file.name) === this.AttachmentFileTypesEnum.Images || this.getType(file.name)==this.AttachmentFileTypesEnum.Pdf;
  }
  
  changeAssetToggle(file:any){
    const index = this.files.findIndex(
      (element) => element.name == file.name
    );
    if (index > -1) {
      this.files[index].isScanForAsset= !this.files[index].isScanForAsset;
      this.scanForAsset.emit(this.files[index]);
    }
  }
}
